export default {
  list: null
};
